import { array, string, bool, func, arrayOf } from 'prop-types';
import columnType from './column';
import sortingType from './sorting';
import actionType from './action';

export default {
  columns: arrayOf(columnType),
  data: array,
  title: string,
  selectable: bool,
  getObjectId: func.isRequired,
  defaultSorting: arrayOf(sortingType),
  showLanguageSelector: bool,
  actions: arrayOf(actionType),
  onRowClick: func
};
